import React from 'react'
import { ModalVariant } from '@at/design-system-patterns'
import { YourSavedSearchListing } from './your-saved-search-listing'
import { StyledModal } from './your-saved-searches.styles'
import { dataAttrTestId } from '@at/formatter-utils'
import { useObserveScreenWidth } from '../../../hooks/use-observe-screen-width.hook'
export interface YourSavedSearchesModalProps {
    handleHideModal: () => void
    isShowing: boolean
}

export const YourSavedSearchesModal = ({ handleHideModal, isShowing }: YourSavedSearchesModalProps) => {
    const { isMobile } = useObserveScreenWidth()
    const modalVariant = isMobile ? ModalVariant.SLIDE : ModalVariant.MEDIUM

    return (
        <StyledModal
            closeText={'Back'}
            hideFn={handleHideModal}
            variation={modalVariant}
            hasBackLink={false}
            modalTitle={'Your saved searches'}
            focusId="modal-button"
            className="your-saved-searches-modal"
            isShowing={isShowing}
            $isMobile={isMobile}
            attributes={{ [dataAttrTestId]: 'your-saved-searches-modal' }}
        >
            <YourSavedSearchListing handleHideModal={handleHideModal} isShowing={isShowing} />
        </StyledModal>
    )
}
